import { ExternalLinkIcon, MailIcon } from 'lucide-react';

import { Button, HoverCard, HoverCardContent, HoverCardTrigger, Text } from '@/_components';

type LinkHoverCardProps = {
  value?: string | null;
  type: 'linkedin' | 'email';
};

export function LinkHoverCard({ value, type }: LinkHoverCardProps) {
  if (!value) {
    return <Text className="text-accent-light dark:text-accent-x-light text-center text-sm font-normal">—</Text>;
  }

  const icon = type === 'linkedin' ? ExternalLinkIcon : MailIcon;
  const title = type === 'linkedin' ? 'LinkedIn Profile' : 'Email Address';

  const handleClick = () => {
    if (type === 'linkedin') {
      window.open(value, '_blank');
    } else if (type === 'email') {
      window.open(`mailto:${value}`, '_blank');
    }
  };

  return (
    <HoverCard openDelay={150} closeDelay={150}>
      <HoverCardTrigger className="cursor-pointer">
        <Button
          icon={icon}
          tag="div"
          size="sm"
          as="link"
          aria-label='"Open link"'
          onClick={handleClick}
          className="text-accent-light dark:text-accent-x-light m-auto text-sm font-normal opacity-40 hover:opacity-100"
        />
      </HoverCardTrigger>
      <HoverCardContent side="top" className="flex w-72 flex-col items-start justify-start px-4 py-5">
        <Text className="text-c-card-foreground text-left font-semibold">{title}</Text>
        <div className="text-c-card-muted text-left break-all">{value}</div>
      </HoverCardContent>
    </HoverCard>
  );
}
